export class Ticket {
    id: number;
    fleet_id: number; 
    driver_no: number;
    location: string;
    violation: string;
    date: string;
    time: string;
    time_string: TimeString;
    hour: number;
    minute: number;
    cost: string;
    demerits: string;
    receipt_no: string;
    note: string;
    file: string; 
    status_id: number;
    ////////////////
    driver: string;
    rego: string;
    status: string;
    ticketTaskCount : number;

}

export interface TimeString {
    hour: number;
    minute: number;
}
